import { connect } from 'react-redux';
import pipe from 'lodash/fp/pipe.js';

import { selectCreateModelFlowStep } from '#selectors/ui/createModelFlow.js';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import RequireCreateModelFlowStep from './RequireCreateModelFlowStep.jsx';

const mapStateToProps = (state, ownProps) => ({
  currentStep: selectCreateModelFlowStep(state, ownProps.routeParams.modelId),
});

export default pipe(connect(mapStateToProps), withRouteParams)(RequireCreateModelFlowStep);
